// extracted by mini-css-extract-plugin
export default {"wrapper":"PlayerLayout_wrapper__YoEz7","container":"PlayerLayout_container__bX7Rd"};